import React, {Suspense, useEffect, useReducer} from 'react';
import useCombinedReducers from 'use-combined-reducers';
import './App.css';
import {ThemeProvider} from '@mui/material/styles';
import {theme} from './Theme';
import {DispatchContext, StateContext} from './store';
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import Home from './view/Home';
import './assets/StyleSheets/_utility.scss';
import {routes} from './routes/Routes';
import {protectedRoutes} from './routes/ProtectedRoutes';
import {ProtectedMain} from './layouts/Admin/ProtectedMain/ProtectedMain';
import {ApiUtils} from './utils/ApiUtils';
import {
  commonReducer, initialRole,
  initialUser,
  loaderReducer,
  loaderStateReducer,
  loaderValue, roleReducer,
  snackbarReducer,
  snackbarValue,
  userReducer
} from './reducers';
import Notify from './common/Snackbar/Snackbar';
import Login from './components/Auth/Login/Login';
import LoginWithNdi from './components/Auth/Login/LoginWithNdi';
import AgentLogin from './components/Auth/Login/AgentLogin';
import Loader from './common/Loader/Loader';
import ConfirmInvitation from './components/Auth/ConfirmInvitation';
import {PlainApiUtils} from './utils/PlainApiUtils';
import SetPassword from './components/Auth/Login/SetPassword';

function App() {
  const [state, dispatch] = useCombinedReducers({
    user: useReducer(userReducer, initialUser),
    role: useReducer(roleReducer, initialRole),
    notifyMessage: useReducer(snackbarReducer, snackbarValue),
    loader: useReducer(loaderReducer, loaderValue),
    loaderState: useReducer(loaderStateReducer, true),
    commonUpdate: useReducer(commonReducer, {change: false})
  });

  ApiUtils.dispatch = dispatch;
  PlainApiUtils.dispatch = dispatch;
  ApiUtils.state = state;
  PlainApiUtils.state = state;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.title = "Come back!";
      } else {
        document.title = "The Museums of Bhutan";
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = "https://app.fastbots.ai/embed.js";
  //   script.defer = true;
  //   script.setAttribute('data-bot-id', 'clyy0p9ee031enibdtystus1e');
  //   document.body.appendChild(script);
  //
  //   // Cleanup function to remove the script when the component unmounts
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <DispatchContext.Provider value={dispatch}>
          <StateContext.Provider value={state}>
            <Notify/>
            <Loader/>
            <Suspense fallback={<div>Loading...</div>}>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Home/>}>
                    {routes.length > 0 && routes.map((route, index) => (
                      <Route
                        key={index}
                        element={route.component}
                        path={route.path}
                      />
                    ))}
                  </Route>
                  <Route path="/management"
                         element={(state?.user?.authenticated || state?.user?.active) ? <ProtectedMain/> : <Navigate to={'/'} replace/>}>
                    {protectedRoutes.map((route, index) => (
                      <Route
                        key={index}
                        {...route}
                        element={route.component}
                        path={route.path}
                      />
                    ))}
                  </Route>
                  <Route path="/login" element={<Login/>}/>
                  <Route path="/agency-login" element={<AgentLogin/>}/>
                  <Route path="/login-with-ndi" element={<LoginWithNdi/>}/>
                  <Route path="/auth/password" element={<SetPassword/>}/>
                  <Route path="/verify-email/" element={<ConfirmInvitation/>}/>
                </Routes>
              </BrowserRouter>
            </Suspense>
          </StateContext.Provider>
        </DispatchContext.Provider>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
